export default __webpack_public_path__ + "static/media/PROTECCION_VEGETAL.1456ab96.jpg";